import { paginationDefault } from 'config/constants';

class CollaboratorsQueryParams {
  search?: string;

  pageSize: number;

  pageNum: number;

  sortBy: SelectType;

  accessLevel?: string;

  collaboratorRole?: string;

  collaboratorStatus?: string;

  vaultStatus?: string;

  vaultType?: string;

  inviteOrigin?: string;

  format?: string;

  focusVaultId?: number;

  constructor(params?: CollaboratorsQueryParamsSerialized | null) {
    this.search = params?.search || '';
    this.pageNum = params?.pageNum || paginationDefault.pageNum;
    this.pageSize = params?.pageSize || paginationDefault.pageSize;
    this.sortBy = params?.sortBy || paginationDefault.alphabeticallyAZ;
    this.accessLevel = params?.accessLevel;
    this.collaboratorRole = params?.collaboratorRole;
    this.collaboratorStatus = params?.collaboratorStatus;
    this.vaultStatus = params?.vaultStatus;
    this.vaultType = params?.vaultType;
    this.inviteOrigin = params?.inviteOrigin;
    this.format = params?.format;
    this.focusVaultId = params?.focusVaultId;
  }
}

export { CollaboratorsQueryParams };
